import { useState } from 'react';
import { useParams } from 'react-router-dom';

import SingleApplicationForm from '../../../pages/recruiting/applicationFormSingle/singleApplicationForm';

import SectionContent from '../../../components/sectionContent/sectionContent';
import HeaderBtn from '../../../components/headerBtn/headerBtn';
import Sidebar from '../../../components/sidebar/Sidebar';

import '../../../scss/App.scss';

const ApplicationFormSingleSection = () => {
	const { id } = useParams<{ id: string }>();

	const [overflowedBtnsCount] = useState<number>(0);

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content='Сменить вакансию'
					purpose='newApplication'
					modalTitle='Сменить вакансию'
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content='Сохранить анкету'
					purpose='saveApplication'
					modalTitle='Сохранить анкету'
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content='Вернуться к списку'
					purpose='navigateToApplicationsList'
					modalTitle='Вернуться к списку'
				/>
			),
		},
	];

	const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);

	const displayedAvailableBtns = filteredAvailableButtons
		?.slice(-(overflowedBtnsCount as number))
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: any, index: any) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				pageName='recruitingSingle'
				section='Набор персонала'
				title='Анкеты'
				tail={'Анкета №' + id}
				availableButtons={displayedAvailableBtns}
				headBlockChildren={displayedHeadBtns}
			>
				<div className='content__single_report'>
					<div className='btns' style={{ margin: '0 0 7px 4px' }}>
					</div>
					<SingleApplicationForm />
				</div>
			</SectionContent>
		</div>
	);
};

export default ApplicationFormSingleSection;
